import axios from 'axios';

import { buildEndpoint, getAuthToken } from '@services/service';
import { PlanFrequency } from '@app-types/service.type';

const BASE_SUBSCRIPTIONS_URL = process.env
    .REACT_APP_SUBSCRIPTIONS_URL as string;

const getAllFrequencies = async (): Promise<PlanFrequency[]> => {
    try {
        const endpoint = buildEndpoint(
            BASE_SUBSCRIPTIONS_URL,
            '/api/admin/plan-frequencies'
        );
        const response = await axios.get(endpoint, {
            headers: { Authorization: getAuthToken() },
        });
        return response.data;
    } catch (err) {
        console.error('Error getting all frequencies:', err);
        return [];
    }
};

export { getAllFrequencies };
